import { queryOptions } from '@tanstack/react-query'
import { getBadgesOptions, POLLING, STALE } from '@/shared/api'

/**
 * Счётчики шапки (`GET /badges`) — единственный запрос, который идёт постоянно на ВСЕХ
 * экранах приложения: точка на колокольчике уведомлений (Task 16, `widgets/app-header`),
 * бейдж «Задачи» и точка «Чатов» в навигации (Task 17, тот же виджет, вторая половина).
 *
 * Слайс `entities/badge` (единственное число — так требует steiger, `fsd/inconsistent-naming`),
 * а не поле в `entities/session` и не часть `entities/notification`:
 * ни туда, ни туда счётчики концептуально не относятся (это не сессия и не лента уведомлений,
 * а отдельная, нарочно дешёвая сущность контракта — `Badges`, `openapi/components/schemas/
 * platform.yaml`), а виджет не может звать виджет напрямую (`widgets → widgets` — межслайсовый
 * импорт внутри слоя, FSD его запрещает). Общий слой ниже обоих виджетов — единственное место,
 * легальное для импорта из них двоих.
 */
export function badgesQuery() {
  return queryOptions({
    ...getBadgesOptions(),
    staleTime: STALE.badges,
    refetchInterval: POLLING.badges,
  })
}
